import React from 'react';
import PropTypes from 'prop-types';
import { DestructiveButtonContainer } from './DestructiveButton.styles';

const DestructiveButton = React.memo(({ functionName, span }) => {
  return (
    <DestructiveButtonContainer onClick={functionName} type="button">
      {span}
    </DestructiveButtonContainer>
  );
});
DestructiveButton.displayName = 'Destructive Button';
DestructiveButton.propTypes = {
  functionName: PropTypes.func,
  span: PropTypes.string,
};

export default DestructiveButton;
